import { cn } from "@/lib/cn";

import { Appear } from "@/components/landing/Appear";

export interface FeatureCard {
  title: string;
  text: string;
}

interface FeatureCardListProps {
  cards: FeatureCard[];
  className?: string;
  stretch?: boolean;
}

export const FeatureCardList = ({ cards, className, stretch }: FeatureCardListProps) => (
  <ul className={className}>
    {cards.map((card) => (
      <Appear
        as="li"
        key={card.title}
        className={cn(
          "flex flex-col gap-3 border-b border-[#e9e9e9] bg-white p-4 last:border-b-0",
          stretch ? "flex-1 justify-center" : "min-h-[7.6875rem]"
        )}
      >
        <h3 className="text-landing-ink text-[1rem] leading-[1.4] font-semibold">{card.title}</h3>
        <p className="text-landing-ink/50 text-[1rem] leading-[1.5] font-semibold">{card.text}</p>
      </Appear>
    ))}
  </ul>
);
